import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';

/**
 * CapitalExpenditure Widget
 */
@Component({
  selector: 'capital-expenditure-widget',
  templateUrl: './capital-expenditure-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './capital-expenditure-widget.component.scss']
})
export class CapitalExpenditureWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'capitalExpenditure', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("capitalExpenditure", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.setupLayouts();
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }

    this.mockupData$ = this.widgetService.loadMockup('capitalExpenditure').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('capitalExpenditure', this.getReport()).pipe();
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);
    return data;
  }

  /**
   * Setup widget's layout if required
   */
  setupLayouts() {
    const fixLayouts = this.availableLayouts.length === 0 && this.currentLayout === 'default';

    if (fixLayouts) {
      this.currentLayout = 'Default';
    }
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }
}
